import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { useScrollbarClasses } from "./useScrollClasses";

const useStyles = makeStyles({
    menuList: {
        maxHeight: '275px',
        overflowX: 'hidden',
        overflowY: 'auto',
        paddingInlineEnd: '1rem',
    },
});

export const useMenuClasses = () => {

    const styles = useStyles();
    const scrollStyles = useScrollbarClasses();

    return {
        classes: {
            menuList: mergeClasses(
                styles.menuList,
                scrollStyles.classes.scrollbarClasses
            )
        }
    };
};